import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

export const useScrollToQueryParam = (offsetSourceId: string = 'navbar') => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollToId = params.get('scroll');

    if (scrollToId) {
      const el = document.getElementById(scrollToId);
      const offsetEl = document.getElementById(offsetSourceId);
      const offset = offsetEl?.offsetHeight || 0;

      if (el) {
        // Delay to ensure the element has rendered
        setTimeout(() => {
          const elementPosition = el.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });

          // Remove the scroll param after scroll
          params.delete('scroll');
          navigate(`${location.pathname}?${params.toString()}`, { replace: true });
        }, 100);
      }
    }
  }, [location.search, offsetSourceId]);
};
